import React from 'react';
import { FoundersAnatomyOfEndurance } from './FoundersAnatomyOfEndurance';
export function Founders() {
  return <FoundersAnatomyOfEndurance data-id="element-613" data-mp="2z6yd1fic42uj" />;
}